import { gql } from '@apollo/client'

export const CREATE_LESSON_FOR_STUDENT_QUERY = gql`
  mutation CreateLessonForStudent($input: CreateLessonForStudentInput!) {
    createLessonForStudent(input: $input) {
      code
      success
      message
      lesson {
        id
      }
    }
  }
`

export const PREPARE_CREATE_LESSON_FOR_STUDENT = gql`
  mutation PrepareCreateLessonForStudent(
    $input: PrepareCreateLessonForStudentInput!
  ) {
    prepareCreateLessonForStudent(input: $input) {
      code
      success
      message
      paymentIntent {
        clientSecret
        amount
        metadata {
          operation
          args
          lineItems {
            amountInCents
            label
            collect
          }
        }
      }
    }
  }
`
